import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FilterStateService } from '@services/filter-state.service';
import { SectionHeaderComponent } from '@shared/section-header/section-header.component';
import { IconSanitizerService, TabItemComponent, TabViewComponent } from 'ngx-lib';
import { IFilterValueAccounts } from '../accounts-filters/accounts-filter.config';
import { AccountsFiltersComponent } from '../accounts-filters/accounts-filters.component';
import { AccountsListComponent } from '../accounts-list/accounts-list.component';
import { AccountsMapComponent } from '../accounts-map/accounts-map.component';

@Component({
    selector: 'app-accounts-main',
    templateUrl: './accounts-main.component.html',
    styleUrls: ['./accounts-main.component.scss'],
    imports: [
        SectionHeaderComponent,
        TabViewComponent,
        TabItemComponent,
        AccountsFiltersComponent,
        AccountsListComponent,
        AccountsMapComponent
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: FilterStateService,
            useClass: FilterStateService<IFilterValueAccounts>
        }
    ]
})
export class AccountsMainComponent {
    listIcon?: SafeHtml;
    mapIcon?: SafeHtml;
    currentTab: string;
    plusIcon?: SafeHtml;

    constructor(
        private readonly router: Router,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        this.listIcon = this.iconSanitizer.getIcon('list');
        this.mapIcon = this.iconSanitizer.getIcon('map');
        this.currentTab = 'List';
        this.plusIcon = this.iconSanitizer.getIcon('plus');
    }

    onCreateNewAccountClicked() {
        this.router.navigate([`/accounts-edit`]);
    }
}
